import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../graphQL-mutation.builder";
import { MutationOptions } from "@apollo/client";

export interface CreateUserModel {
  nombre: string;
  user: string;
  mail: string;
  apellidos: string;
  idioma: string;
  zonaHoraria: string;
  rol: string[];
  enabled: boolean;
}

export class CreateUserBuilder {
  private _USERNAME: string;
  private _USERUSERNAME: string;
  private _USERMAIL: string;
  private _USERFIRSTNAME: string;
  private _USERLANGUAGE: string;
  private _USERTIMEZONE: string;
  private _USERROL: string[];
  private _USERENABLED: boolean;

  private get _mutation() {
    return gql`
      mutation createUsuario(
        $nombre: String
        $user: String
        $mail: String
        $apellidos: String
        $idioma: String
        $zonaHoraria: String
        $rol: [String]
        $enabled: Boolean
      ) {
        createUsuario(
          nombre: $nombre
          usuario: $user
          mail: $mail
          apellidos: $apellidos
          idioma: $idioma
          zonaHoraria: $zonaHoraria
          rol: $rol
          enabled: $enabled
        ) {
          uuid
        }
      }
    `;
  }

  public withName(name: string): this {
    this._USERNAME = name;
    return this;
  }

  public withUser(user: string): this {
    this._USERUSERNAME = user;
    return this;
  }

  public withMail(mail: string): this {
    this._USERMAIL = mail;
    return this;
  }

  public withFirstName(firstName: string): this {
    this._USERFIRSTNAME = firstName;
    return this;
  }

  public withLanguage(language: string): this {
    this._USERLANGUAGE = language;
    return this;
  }

  public withTimeZone(timeZone: string): this {
    this._USERTIMEZONE = timeZone;
    return this;
  }

  public withRol(rol: string[]): this {
    this._USERROL = rol;
    return this;
  }

  public withEnabled(userEnabled: boolean): this {
    this._USERENABLED = userEnabled;
    return this;
  }

  public build(): MutationOptions {
    const mutationParams: CreateUserModel = {
      nombre: this._USERNAME,
      user: this._USERUSERNAME,
      mail: this._USERMAIL,
      apellidos: this._USERFIRSTNAME,
      idioma: this._USERLANGUAGE,
      zonaHoraria: this._USERTIMEZONE,
      rol: this._USERROL,
      enabled: this._USERENABLED,
    };
    const graphQlMutationBuilder: GraphQlMutationBuilder =
      new GraphQlMutationBuilder();
    return graphQlMutationBuilder
      .withMutation(this._mutation)
      .withParams(mutationParams)
      .build();
  }
}
